import { dashboardAdminService } from '@/services';

export const dashboardAdminModule = {
  namespaced: true,
  state: () => ({
    entitiesNotRegistered:{
      data: {
        orders: 0,
        orders_back: 0,
        purchases: 0
      },
      error: null,
    },
    entityExcel:{
      data: null,
      error: null,
    },
    queuesError:{
      data: null,
      error: null,
    },
  }),
  mutations: {
    getEntitiesNotRegistered(state,) {
      dashboardAdminService.getEntitiesNotRegistered()
      .then((res) => {
        state.entitiesNotRegistered.data = { ...res }
        state.entitiesNotRegistered.error = null
      })
      .catch((error) => {
        state.entitiesNotRegistered.data = null
        state.entitiesNotRegistered.error = error
      });    
    },
    getEntityExcel(state,request){
      dashboardAdminService.getEntityAsExcel(request.filters, request.entity)
      .then((excel) => {
        state.entityExcel.data = excel
      })
      .catch((error) => {
        state.entityExcel.data = null
        state.entityExcel.error = error
      });
    },
    getQueuesError(state,filters) {
      dashboardAdminService.getQueuesError(filters)
      .then((res) => {
        state.queuesError.data = { ...res }
        state.queuesError.error = null
      })
      .catch((error) => {
        state.queuesError.data = null
        state.queuesError.error = error
      });    
    },
  }
}